export enum CourseLocation {
  PRESENTIAL = 'presential',
  ONLINE = 'online',
  HYBRID = 'hybrid'
}
